import type { FaqItem } from '../../../content/landings/types';
import { LandingSection } from '../layout/landing-section';

interface Props {
  title: string;
  items: FaqItem[];
}

/**
 * FAQ — нативные <details>/<summary>, плюс поворачивается в крестик при
 * открытии. Колбэка на раскрытие намеренно нет: событие `faq_open` мы не
 * заводим (см. задачу 8).
 *
 * Макет сужает `.wrap` этой секции до 820px (а не стандартных 1120) — общий
 * `<LandingSection>` даёт 1120, поэтому здесь добавляем свой `max-w-[820px]
 * mx-auto` ВНУТРИ него, без второго `px-5` (горизонтальный отступ уже
 * применён примитивом).
 */
export function Faq({ title, items }: Props) {
  return (
    <LandingSection id="faq" top="sm">
      <div className="mx-auto max-w-[820px]">
        <h2 className="mb-3 text-[clamp(26px,4.2vw,38px)] font-extrabold leading-[1.12] tracking-[-0.02em] text-ink">
          {title}
        </h2>
        <div className="mt-5">
          {items.map((item) => (
            <details
              key={item.q}
              className="group mb-2.5 rounded-xl border border-edge bg-bone-surface shadow-m-sm [&_summary::-webkit-details-marker]:hidden"
            >
              <summary className="relative cursor-pointer list-none py-[17px] pl-5 pr-[46px] text-base font-bold text-ink">
                {item.q}
                <span
                  aria-hidden="true"
                  className="absolute right-[18px] top-[13px] text-[22px] font-semibold text-brand transition-transform duration-150 group-open:rotate-45"
                >
                  +
                </span>
              </summary>
              <div className="px-5 pb-[17px] text-[15px] text-ink-soft">{item.a}</div>
            </details>
          ))}
        </div>
      </div>
    </LandingSection>
  );
}
